export enum ReferralSource {    
    MedicalProfessional = 2,
    WebSearch = 4,
    WordOfMouth = 5,
    Facebook = 7,
    OtherSocialMedia = 8,
    Other = 6
}